import React, { useContext, useState } from "react";
import SectionCard from "../../profiles/SectionCard";
import CompanyDetailTile from "./company_detail_tile";
import { CompanyContext } from "../data/company_context_management";

// Truncation threshold, duplicated verbatim from AboutSection's own bio renderer (and from Product's
// OverviewCard, which duplicated it first) — the recipe's third occurrence, not yet the signal to
// extract a shared helper (WET before DRY).
const DESCRIPTION_CHAR_LIMIT = 280;

// The company About section, renamed Overview and given a fact-tile row per the design.
// The design's tile set also includes Industry, Company Size, Headquarters, Founded,
// and third-party Domain Authority/Unique Visits stats — none of which any Company column backs
// today, so only the one fact this page actually has real data for renders: the company's website,
// the same contact-details lookup the header used before its actions row moved to View
// Website/Share Profile. Rendering the others would mean inventing data, not composing it.
function CompanyOverview() {
  const { company, viewerContext, setOpenEditModal } = useContext(CompanyContext);
  const [expanded, setExpanded] = useState(false);
  const editable = !!viewerContext?.editable;

  const websiteUrl = (company.contact_details || []).find((detail) => detail.type === "url")?.value;
  const showWebsiteTile = !!websiteUrl;
  const showDescription = !!company.description;

  if (!showWebsiteTile && !showDescription) return null;

  // Count/slice by code point (not UTF-16 unit) so a boundary never splits an emoji surrogate pair.
  const descriptionChars = company.description ? Array.from(company.description) : [];
  const shouldTruncateDescription = descriptionChars.length > DESCRIPTION_CHAR_LIMIT;
  const collapsedDescription = `${descriptionChars
    .slice(0, DESCRIPTION_CHAR_LIMIT)
    .join("")
    .replace(/[ \t]+$/, "")}…`;

  return (
    <SectionCard
      id="company-section-overview"
      title="Overview"
      editable={editable}
      onEdit={() => setOpenEditModal("MAIN")}
      editButtonId="modal-button-MAIN"
    >
      {showWebsiteTile && (
        <div className={`row${showDescription ? " border-bottom pb-2 mb-3" : ""}`}>
          <CompanyDetailTile icon="fa-solid fa-globe" label="Website">
            <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
              {websiteUrl}
            </a>
          </CompanyDetailTile>
        </div>
      )}

      {showDescription && (
        <div style={{ whiteSpace: "pre-wrap" }} className="text-break">
          {shouldTruncateDescription ? (
            <>
              {expanded ? company.description : collapsedDescription}{" "}
              <button
                type="button"
                className="btn btn-link p-0 align-baseline text-primary border-0"
                style={{ font: "inherit" }}
                aria-expanded={expanded}
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "see less" : "see more"}
              </button>
            </>
          ) : (
            company.description
          )}
        </div>
      )}
    </SectionCard>
  );
}

export default CompanyOverview;
